import React from "react";
import { Typography, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import CloseIcon from "@material-ui/icons/Close";

const BLUE   = "#3B82F6";
const BORDER = "#dde0ee";
const SURFACE = "#f5f6fa";
const TEXT   = "#1a1d2e";
const MUTED  = "#7b80a0";

export function fmtSize(bytes) {
  return bytes > 1_048_576
    ? (bytes / 1_048_576).toFixed(1) + " MB"
    : Math.round(bytes / 1024) + " KB";
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: 9,
    background: SURFACE,
    border: `0.5px solid ${BORDER}`,
    borderRadius: 6,
    padding: "7px 11px",
    marginBottom: 6,
  },
  fileIcon: { color: BLUE, fontSize: 17 },
  name: {
    flex: 1,
    fontSize: 12,
    color: TEXT,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  size: { fontSize: 11, color: MUTED, flexShrink: 0, marginRight: 2 },
  removeBtn: {
    padding: 2,
    color: MUTED,
    "&:hover": { color: "#e05c5c" },
  },
}));

export default function FileItem({ file, onRemove }) {
  const cls = useStyles();
  return (
    <div className={cls.root}>
      <InsertDriveFileOutlinedIcon className={cls.fileIcon} />
      <Typography className={cls.name}>{file.name}</Typography>
      <Typography className={cls.size}>{fmtSize(file.size)}</Typography>
      <Tooltip title="Remove">
        <IconButton size="small" className={cls.removeBtn} onClick={onRemove}>
          <CloseIcon style={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </div>
  );
}